var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "page search-page" }, [
    _c("div", { staticClass: "search-page__container" }, [
      _c("div", { staticClass: "search-bar" }, [
        _c("div", { staticClass: "search-bar__icon" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
              },
            },
            [
              _c("circle", { attrs: { cx: "11", cy: "11", r: "8" } }),
              _c("path", { attrs: { d: "m21 21-4.35-4.35" } }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.query,
              expression: "query",
              modifiers: { trim: true },
            },
          ],
          ref: "searchInput",
          staticClass: "search-bar__input",
          attrs: { type: "text", placeholder: "Search regulatory content..." },
          domProps: { value: _vm.query },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.doSearch.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.query = $event.target.value.trim()
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      !_vm.hasResults && !_vm.loading
        ? _c(
            "div",
            { staticClass: "suggestion-pills" },
            _vm._l(_vm.defaultSuggestions, function (suggestion) {
              return _c(
                "button",
                {
                  key: suggestion,
                  staticClass: "suggestion-pill",
                  on: {
                    click: function ($event) {
                      return _vm.useSuggestion(suggestion)
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(suggestion) + "\n      ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.refinements.length > 0 && _vm.hasResults
        ? _c(
            "div",
            { staticClass: "refinement-section" },
            [
              _c(
                "div",
                {
                  staticClass: "refinement-header",
                  on: {
                    click: function ($event) {
                      _vm.refinementsOpen = !_vm.refinementsOpen
                    },
                  },
                },
                [
                  _c("span", { staticClass: "refinement-header__icon" }, [
                    _vm._v("✨"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "refinement-header__title" }, [
                    _vm._v("Narrow your search"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "refinement-header__subtitle" }, [
                    _vm._v(
                      "\n          Your current search term is quite broad — try a more targeted query\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "refinement-header__toggle",
                      attrs: {
                        "aria-label": _vm.refinementsOpen
                          ? "Collapse"
                          : "Expand",
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          class: { "is-open": _vm.refinementsOpen },
                          attrs: {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                          },
                        },
                        [_c("path", { attrs: { d: "M3 4.5 L6 7.5 L9 4.5" } })]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "refinement-header__close",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.dismissRefinements.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                          },
                        },
                        [_c("path", { attrs: { d: "M2 2l8 8M10 2l-8 8" } })]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide" } }, [
                _vm.refinementsOpen
                  ? _c(
                      "div",
                      { staticClass: "refinement-cards" },
                      _vm._l(_vm.refinements, function (ref, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticClass: "refinement-card",
                            on: {
                              click: function ($event) {
                                return _vm.useRefinement(ref)
                              },
                            },
                          },
                          [
                            _c("div", {
                              staticClass: "refinement-card__indicator",
                              class:
                                "refinement-card__indicator--" +
                                _vm.refineColor(idx),
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "refinement-card__content" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "refinement-card__label" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          ref.label ||
                                            ref.dimension ||
                                            "Suggestion"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "refinement-card__query" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(ref.query || ref) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "refinement-card__action" },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: { cx: "11", cy: "11", r: "8" },
                                    }),
                                    _c("path", {
                                      attrs: { d: "m21 21-4.35-4.35" },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasResults
        ? _c("div", { staticClass: "facet-section" }, [
            _vm.facets.type.length
              ? _c("div", { staticClass: "facet-row" }, [
                  _c("span", { staticClass: "facet-row__label" }, [
                    _vm._v("Type"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "facet-row__pills" },
                    _vm._l(_vm.facets.type, function (f) {
                      return _c(
                        "button",
                        {
                          key: "type-" + f.name,
                          staticClass: "facet-pill",
                          class: {
                            "facet-pill--active":
                              _vm.activeFilters.type === f.name,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleFilter("type", f.name)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formatContentType(f.name)) +
                              "\n            "
                          ),
                          _c("span", { staticClass: "facet-pill__count" }, [
                            _vm._v(_vm._s(f.count)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.facets.jurisdiction.length
              ? _c("div", { staticClass: "facet-row" }, [
                  _c("span", { staticClass: "facet-row__label" }, [
                    _vm._v("Jurisdiction"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "facet-row__pills" },
                    [
                      _vm._l(_vm.visibleJurisdictions, function (f) {
                        return _c(
                          "button",
                          {
                            key: "jur-" + f.name,
                            staticClass: "facet-pill",
                            class: {
                              "facet-pill--active":
                                _vm.activeFilters.jurisdiction === f.name,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleFilter("jurisdiction", f.name)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(f.name) +
                                "\n            "
                            ),
                            _c("span", { staticClass: "facet-pill__count" }, [
                              _vm._v(_vm._s(f.count)),
                            ]),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.facets.jurisdiction.length > 6
                        ? _c(
                            "button",
                            {
                              staticClass: "facet-pill facet-pill--more",
                              on: {
                                click: function ($event) {
                                  _vm.showAllJurisdictions =
                                    !_vm.showAllJurisdictions
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.showAllJurisdictions
                                      ? "Show less"
                                      : `+${
                                          _vm.facets.jurisdiction.length - 6
                                        } more`
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.facets.source.length
              ? _c("div", { staticClass: "facet-row" }, [
                  _c("span", { staticClass: "facet-row__label" }, [
                    _vm._v("Source"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "facet-row__pills" },
                    _vm._l(_vm.facets.source, function (f) {
                      return _c(
                        "button",
                        {
                          key: "src-" + f.name,
                          staticClass: "facet-pill",
                          class: {
                            "facet-pill--active":
                              _vm.activeFilters.source === f.name,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleFilter("source", f.name)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formatSource(f.name)) +
                              "\n            "
                          ),
                          _c("span", { staticClass: "facet-pill__count" }, [
                            _vm._v(_vm._s(f.count)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasResults
        ? _c("div", { staticClass: "results-header" }, [
            _c("div", { staticClass: "results-header__count" }, [
              _c("strong", [_vm._v(_vm._s(_vm.accessibleCount))]),
              _vm._v(" accessible\n        "),
              _vm.lockedCount > 0
                ? _c("span", { staticClass: "results-header__locked" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.lockedCount))]),
                    _vm._v(" locked\n        "),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "results-header__sort" },
              _vm._l(_vm.sortOptions, function (s) {
                return _c(
                  "button",
                  {
                    key: s.value,
                    staticClass: "sort-btn",
                    class: { "sort-btn--active": _vm.sortBy === s.value },
                    on: {
                      click: function ($event) {
                        _vm.sortBy = s.value
                      },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(s.label) + "\n        ")]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "skeleton-list" },
            _vm._l(6, function (i) {
              return _c("div", { key: i, staticClass: "skeleton-card" }, [
                _vm._m(1, true),
                _vm._v(" "),
                _c("div", {
                  staticClass: "skeleton-line",
                  staticStyle: {
                    width: "75%",
                    height: "16px",
                    "margin-bottom": "10px",
                  },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "skeleton-line",
                  staticStyle: {
                    width: "100%",
                    height: "12px",
                    "margin-bottom": "6px",
                  },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "skeleton-line",
                  staticStyle: { width: "66%", height: "12px" },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "skeleton-line",
                  staticStyle: {
                    width: "33%",
                    height: "6px",
                    "border-radius": "3px",
                    "margin-top": "12px",
                  },
                }),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasResults && !_vm.loading
        ? _c(
            "div",
            { staticClass: "results-list" },
            _vm._l(_vm.paginatedResults, function (article) {
              return _c(
                "div",
                {
                  key: article.id,
                  staticClass: "result-card",
                  class: { "result-card--blocked": !article.accessible },
                },
                [
                  _c("div", { staticClass: "result-card__meta" }, [
                    _c("span", { staticClass: "result-card__type" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formatContentType(article.content_type)) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    article.source_type
                      ? _c(
                          "span",
                          {
                            staticClass: "result-card__source",
                            class:
                              "result-card__source--" + article.source_type,
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatSource(article.source_type)) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    article.jurisdiction
                      ? _c(
                          "span",
                          { staticClass: "result-card__jurisdiction" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(article.jurisdiction) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  article.accessible && article.platform_url
                    ? _c(
                        "a",
                        {
                          staticClass: "result-card__title",
                          attrs: {
                            href: article.platform_url,
                            target: "_blank",
                            rel: "noopener",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(article.title) +
                              "\n        "
                          ),
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass:
                            "result-card__title result-card__title--blocked",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(article.title) +
                              "\n        "
                          ),
                        ]
                      ),
                  _vm._v(" "),
                  article.summary && article.accessible
                    ? _c("p", { staticClass: "result-card__summary" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(article.summary) +
                            "\n        "
                        ),
                      ])
                    : article.summary && !article.accessible
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "result-card__summary result-card__summary--blurred",
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(article.summary.slice(0, 80))),
                          ]),
                          _c("span", { staticClass: "blur-text" }, [
                            _vm._v(_vm._s(article.summary.slice(80))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "result-card__footer" }, [
                    _c("div", { staticClass: "result-card__score-row" }, [
                      _c("div", { staticClass: "score-bar" }, [
                        _c("div", {
                          staticClass: "score-bar__fill",
                          class: {
                            "score-bar__fill--blocked": !article.accessible,
                          },
                          style: {
                            width: _vm.scorePercent(article.score) + "%",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "score-bar__label" }, [
                        _vm._v(_vm._s(_vm.scorePercent(article.score)) + "%"),
                      ]),
                    ]),
                    _vm._v(" "),
                    article.published_date
                      ? _c("span", { staticClass: "result-card__date" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formatDate(article.published_date)) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !article.accessible
                      ? _c(
                          "svg",
                          {
                            staticClass:
                              "result-card__icon result-card__icon--lock",
                            attrs: {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        )
                      : _c(
                          "svg",
                          {
                            staticClass:
                              "result-card__icon result-card__icon--arrow",
                            attrs: {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M9 5l7 7-7 7",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                  ]),
                  _vm._v(" "),
                  !article.accessible && article.upsell
                    ? _c("div", { staticClass: "result-card__upsell" }, [
                        article.upsell.reason === "upgrade_tier"
                          ? _c(
                              "span",
                              { staticClass: "result-card__upsell-text" },
                              [
                                _vm._v("\n            Requires "),
                                _c("strong", [
                                  _vm._v(_vm._s(article.upsell.required_tier)),
                                ]),
                                _vm._v(" tier\n          "),
                              ]
                            )
                          : article.upsell.reason === "add_jurisdiction"
                          ? _c(
                              "span",
                              { staticClass: "result-card__upsell-text" },
                              [
                                _vm._v("\n            Requires "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(article.upsell.required_jurisdiction)
                                  ),
                                ]),
                                _vm._v(" jurisdiction\n          "),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "result-card__upsell-badge" },
                          [_vm._v("Upgrade")]
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasMoreResults
        ? _c("div", { staticClass: "load-more" }, [
            _c(
              "button",
              { staticClass: "load-more__btn", on: { click: _vm.loadMore } },
              [_vm._v("\n        Show more results\n      ")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.searchPerformed && !_vm.hasResults
        ? _c("div", { staticClass: "no-results" }, [
            _c("p", [
              _vm._v("No results found for “"),
              _c("strong", [_vm._v(_vm._s(_vm.lastQuery))]),
              _vm._v("”"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Try broadening your search or using different keywords."),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "search-bar__shortcut" }, [
      _c("kbd", [_vm._v("Ctrl")]),
      _vm._v(" "),
      _c("kbd", [_vm._v("K")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "skeleton-card__badges" }, [
      _c("span", {
        staticClass: "skeleton-line",
        staticStyle: { width: "80px", height: "18px", "border-radius": "12px" },
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "skeleton-line",
        staticStyle: { width: "60px", height: "18px", "border-radius": "12px" },
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "skeleton-line",
        staticStyle: { width: "90px", height: "18px", "border-radius": "12px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }